'use strict';

import { bindViewportAwareDropdown } from '../shared/floating-dropdown-position.js';

export function bindMultiSelectDropdownTrigger($trigger, options) {
    bindViewportAwareDropdown($trigger, Object.assign({
        preferredMaxHeight: 300,
        namespace: 'msddPos',
    }, options || {}));
}

export function bindMultiSelectDropdownTriggersIn($root, options) {
    const $scope = $root && $root.length ? $root : $(document);
    $scope.find('.multi-select-dropdown-trigger[data-toggle="dropdown"]').each(function () {
        bindMultiSelectDropdownTrigger($(this), options);
    });
}

export function createMultiSelectDropdown(config, handlers) {
    const allLabel = config.allLabel || 'All Columns';
    const allId = config.allCheckboxId || config.allCheckboxSelector.replace(/^#/, '');
    const ns = config.eventNamespace || 'msdd';
    const options = Array.isArray(config.options) && config.options.length
        ? config.options.map((o) => (typeof o === 'string' ? { value: o, label: o } : o))
        : [];

    function getSelected() {
        const selected = [];
        const seen = {};
        $(config.itemCheckboxSelector + ':checked').each(function () {
            const id = $(this).attr('id');
            const val = $(this).val();
            if (id === allId || !val || val === 'all') {
                return;
            }
            const key = String(val);
            if (seen[key]) {
                return;
            }
            seen[key] = true;
            selected.push(val);
        });
        return selected;
    }

    function updateItemClasses() {
        $(config.itemCheckboxSelector).each(function () {
            $(this).closest('.multi-select-dropdown-item').toggleClass('active', $(this).is(':checked'));
        });
    }

    const emptyLabel = config.emptyLabel || allLabel;
    const nounSingular = config.itemNounSingular || 'Column';
    const nounPlural = config.itemNounPlural || 'Columns';

    function updateText() {
        const $text = $(config.textSelector);
        if (!$text.length) return;
        const selected = getSelected();
        const total = options.length;
        const $all = $(config.allCheckboxSelector);
        if (selected.length === 0) {
            $text.text(emptyLabel);
        } else if ($all.is(':checked') || selected.length === total) {
            $text.text(allLabel);
        } else if (selected.length === 1) {
            const opt = options.find((o) => o.value === selected[0]);
            $text.text(opt ? opt.label : '1 ' + nounSingular);
        } else {
            $text.text(selected.length + ' ' + nounPlural);
        }
    }

    function syncFromCheckboxes() {
        updateItemClasses();
        updateText();
    }

    $(document).off('change.' + ns, config.allCheckboxSelector).on('change.' + ns, config.allCheckboxSelector, function () {
        const checked = $(this).is(':checked');
        $(config.itemCheckboxSelector).each(function () {
            if ($(this).attr('id') !== allId) $(this).prop('checked', checked);
        });
        syncFromCheckboxes();
        if (handlers && handlers.onAllChange) handlers.onAllChange(checked);
    });

    $(document).off('change.' + ns, config.itemCheckboxSelector).on('change.' + ns, config.itemCheckboxSelector, function () {
        if ($(this).attr('id') === allId || $(this).val() === 'all') return;
        const selected = getSelected();
        const total = options.length;
        $(config.allCheckboxSelector).prop('checked', total > 0 && selected.length === total);
        syncFromCheckboxes();
        if (handlers && handlers.onItemChange) handlers.onItemChange(selected);
    });

    if (config.searchSelector) {
        $(document)
            .off('input.' + ns, config.searchSelector)
            .on('input.' + ns, config.searchSelector, function () {
                const term = (this.value || '').toLowerCase();
                $(config.itemCheckboxSelector).each(function () {
                    const $item = $(this).closest('.multi-select-dropdown-item');
                    if ($(this).attr('id') === allId) {
                        $item.removeClass('hidden');
                        return;
                    }
                    const text = ($item.find('span').text() || '').toLowerCase();
                    $item.toggleClass('hidden', term !== '' && text.indexOf(term) === -1);
                });
            });
        $(document)
            .off('keydown.' + ns, config.searchSelector)
            .on('keydown.' + ns, config.searchSelector, function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                }
            });
    }

    if (config.triggerSelector) {
        bindMultiSelectDropdownTrigger($(config.triggerSelector), {
            namespace: ns + 'Pos',
            preferredMaxHeight: config.preferredMaxHeight,
        });
    }

    return { getSelected, updateItemClasses, updateText };
}
